import { render } from "./AboutUsComponent.vue?vue&type=template&id=6d03c7d4&scoped=true"
import script from "./AboutUsComponent.vue?vue&type=script&lang=js"
export * from "./AboutUsComponent.vue?vue&type=script&lang=js"

import "./AboutUsComponent.vue?vue&type=style&index=0&id=6d03c7d4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d03c7d4"]])

export default __exports__